// extracted by mini-css-extract-plugin
module.exports = {"stories":"Stories_stories__1A8PH","noResults":"Stories_noResults__2_r59"};